console.log(
    "%cb3 house | Creative Digital Production 😎",
    "background:#455CE9; color:#E9EAEB; padding:3px 6px;"
);
